import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import {useUser} from "hooks/StateHooks"
import {FormType} from "mixins/FormTypes"
import {Http} from "mixins/http"
import React, {createRef} from "react"
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Form from "../mixins/form"
import Modal from "./Modal"
import Trans from './Trans'
import {translate} from '../filters'

const alert = withReactContent(Swal)

type SupportModalProps = {
  hideModal: () => void
}

type SupportModalState = {
  form: FormType
}

class SupportModal extends React.Component<SupportModalProps, SupportModalState> {
  private user = useUser()
  private subjectRef = createRef<HTMLInputElement>()
  private messageRef = createRef<HTMLTextAreaElement>()
  private form: FormType = new Form({from: this.user.employee.Email, subject: '', message: ''})

  constructor(props: SupportModalProps) {
    super(props)
    this.state = {
      form: this.form,
    }
  }

  changeForm = () => {
    this.form.subject = this.subjectRef.current ? this.subjectRef.current.value : ''
    this.form.message = this.messageRef.current ? this.messageRef.current.value : ''

    this.setState({form: this.form})
  }

  send = async () => {
    await Http.post('/support', {
      form: this.form,
      state: this
    })

    if (this.state.form.successful) {
      await alert.fire({
        type: 'success',
        title: translate('Ihre Support-Meldung ist erfolgreich eingegangen!'),
        showConfirmButton: false,
        timer: 2000
      })
    }

    this.props.hideModal()
  }

  render() {
    const header = (
      <div className="px-3 py-2 text-gray-700 font-semibold flex flex-row justify-between items-center">
        <span><Icon icon="paper-plane"/> <Trans>Support Kontaktieren</Trans></span>
        <button onClick={this.props.hideModal} className={"flex border-0 font-semibold text-lg rounded text-gray-600 hover:text-gray-700 px-2 py-1"} type="button">
          <Icon icon="times"/>
        </button>
      </div>
    )
    const footer = (
      <div className="flex flex-row justify-end p-2">
        <button disabled={this.state.form.busy} onClick={() => this.props.hideModal()} className={"border-0 rounded text-gray-500 hover:bg-gray-200 px-2 py-1 mr-4 " + (this.state.form.busy ? 'cursor-not-allowed opacity-75' : '')} type="button">
          Abbrechen
        </button>
        <button disabled={this.state.form.busy || !this.state.form.subject || !this.state.form.message} onClick={this.send} className={"border-0 rounded bg-gray-300 hover:bg-gray-400 text-gray-700 px-2 py-1 shadow " + (this.state.form.busy || !this.state.form.subject || !this.state.form.message ? 'cursor-not-allowed opacity-75' : '')} type="button">
          <div>
            {
              this.state.form.busy ?
                <Icon icon="spinner" className="fa-spin"/>
                :
                <Icon icon="envelope"/>
            }
            <span className={'ml-2'}><Trans>Nachricht senden</Trans></span>
          </div>
        </button>
      </div>
    )
    const body = (
      <div className={"text-gray-700 flex flex-col"}>
        <div className="w-full px-4 py-1 my-3">
          <Icon icon="envelope"/>
          <span className='text-gray-700 font-semibold'> {this.state.form.from}</span>
        </div>

        <div className="w-full px-4 py-1 my-3">
          <input value={this.state.form.subject} ref={this.subjectRef} onChange={this.changeForm} className="bg-gray-200 text-gray-800 border-gray-200 hover:bg-gray-100 focus:bg-gray-100 focus:border-gray-300 w-full px-3 py-2 rounded shadow" id="support-subject" placeholder="Betreff" type="text"/>
        </div>

        <div className="w-full px-4 py-1 my-3">
          <textarea value={this.state.form.message} ref={this.messageRef} onChange={this.changeForm} className="bg-gray-200 text-gray-800 border-gray-200 hover:bg-gray-100 focus:bg-gray-100 focus:border-gray-300 w-full px-3 py-2 rounded shadow h-32" placeholder="Nachricht"/>
        </div>
      </div>
    )
    return (
      <Modal header={header} footer={footer} body={body}/>
    )
  }
}

export default SupportModal
